var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0967 12.9397L8.69668 11.4897L12.2467 7.9397H0.0966797V5.9397H12.2467L8.69668 2.3897L10.0967 0.939697L16.0967 6.9397L10.0967 12.9397Z",
    fill: "#F4F4F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightAlt);
export default __webpack_public_path__ + "static/media/arrow_right_alt.036c465615691f7e8d56b462a9b48bc2.svg";
export { ForwardRef as ReactComponent };